"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1276],{

/***/ 21206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ recursiveApplyTransformation; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

const recursiveApplyTransformation = (/* eslint-disable @typescript-eslint/no-explicit-any */ value, transformation)=>{
    /* eslint-enable @typescript-eslint/no-explicit-any */ if (value == null) return value;
    if (value instanceof File) return value;
    if (typeof value === "string") {
        return transformation(value);
    }
    if (Array.isArray(value)) {
        return value.map((val)=>recursiveApplyTransformation(val, transformation));
    }
    if (typeof value === "object") {
        if (value instanceof Blob || value instanceof File) return value;
        if (value instanceof Date) return value;
        return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.mapValues)(value, (val)=>recursiveApplyTransformation(val, transformation));
    }
    return value;
};


/***/ }),

/***/ 35838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YX": function() { return /* binding */ formatInUTC; },
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "o8": function() { return /* binding */ formatDateOnly; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16044);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31807);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23107);

const formatDate = (value)=>value ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value), "MM/dd/yyyy hh:mm aa") : "";
const formatDateOnly = (value)=>value ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value), "MM/dd/yyyy") : "";
const formatTime = (value)=>value ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value), "hh:mm aa") : "";
const formatInUTC = (value)=>{
    const date = new Date(value);
    return "".concat((0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date, date.getTimezoneOffset()), "dd/MM/yyyy hh:mm aa"), " UTC");
};


/***/ }),

/***/ 50110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ClientSide; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



const ClientSideInner = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 9015).then(__webpack_require__.bind(__webpack_require__, 59015)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(59015)
            ]
    },
    ssr: false
});
const ClientSide = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClientSideInner, {
        children: children
    });
};


/***/ }),

/***/ 87586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ PageCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/ArrowBack.js
var ArrowBack = __webpack_require__(28504);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/next/ClientSide.tsx
var ClientSide = __webpack_require__(50110);
// EXTERNAL MODULE: ../../node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(94187);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx + 19 modules
var styles = __webpack_require__(71951);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../node_modules/antd/es/layout/index.js
var layout = __webpack_require__(37488);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PageCard/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: ",
        ";\n  height: ",
        ";\n\n  .ant-layout-header {\n    height: unset;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex: 0 auto;\n  flex-direction: column;\n  padding: 48px 0px 72px;\n  border-radius: 18px;\n  background: ",
        ";\n  margin: 36px;\n  max-height: ",
        ";\n\n  @media print {\n    margin: 4px 0px;\n    padding: 0px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 888;\n  background: ",
        ";\n  padding: 12px 72px;\n  align-items: center;\n  border-bottom: 1px solid\n    ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 36px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 48px 72px 0;\n  overflow-y: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}



const Layout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "" : "auto";
}, (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? " calc(100vh - 72px)" : "";
});
const Card = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "100%" : "";
});
const Header = (0,styled_components_browser_esm/* default */.ZP)(layout/* default.Header */.Z.Header)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme , $showBorder  } = param;
    return $showBorder ? theme.colors.grey20 : "transparent";
});
const HeaderSection = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
const ActionsWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
const Content = (0,styled_components_browser_esm/* default */.ZP)(layout/* default.Content */.Z.Content)(_templateObject5(), (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "auto" : "";
});
const BackButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(_templateObject6());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PageCard/index.tsx








const COLLAPSE_THRESHOLD = 84;
const COLLAPSE_THRESHOLD_RESERVE = 12;
const PageCard = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { title , subtitle , hasBackButton , headerActions , children , footer , contentStyle , redirectBackRoute , allowScroll  } = param;
    const router = (0,next_router.useRouter)();
    const scrollRef = react.useRef(null);
    const [showCollapsedHeader, setShowCollapsedHeader] = react.useState(false);
    const handleScroll = (0,react.useCallback)(()=>{
        if (scrollRef.current) {
            const currentScrollY = scrollRef.current.scrollTop;
            // to avoid attaching multiple listeners to scrollRef
            // (react state cannot be used to track the changes here)
            const wentOverThreshold = scrollRef.current.classList.contains("over-threshold");
            if (currentScrollY > COLLAPSE_THRESHOLD && !wentOverThreshold) {
                setShowCollapsedHeader(true);
                scrollRef.current.classList.add("over-threshold");
            } else if (currentScrollY < COLLAPSE_THRESHOLD - COLLAPSE_THRESHOLD_RESERVE && wentOverThreshold) {
                setShowCollapsedHeader(false);
                scrollRef.current.classList.remove("over-threshold");
            }
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (scrollRef.current) {
            scrollRef.current.addEventListener("scroll", handleScroll, {
                passive: true
            });
        }
    }, [
        handleScroll
    ]);
    (0,react.useImperativeHandle)(ref, ()=>({
            scrollToBottom: ()=>{
                if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            },
            scrollToTop: ()=>{
                if (scrollRef.current) scrollRef.current.scrollTop = 0;
            }
        }));
    const handleRedirectBack = ()=>{
        redirectBackRoute ? router.replace(redirectBackRoute) : router.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSide/* ClientSide */.B, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            ref: scrollRef,
            $allowScroll: allowScroll,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                $allowScroll: allowScroll,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        $showBorder: showCollapsedHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                children: [
                                    hasBackButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                                        actionType: "secondary",
                                        size: "large",
                                        onClick: handleRedirectBack,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                        size: 0,
                                        direction: "vertical",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                level: showCollapsedHeader ? 2 : 1,
                                                children: title
                                            }),
                                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                level: 3,
                                                children: subtitle
                                            })
                                        ]
                                    })
                                ]
                            }),
                            headerActions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsWrapper, {
                                children: headerActions
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        style: contentStyle,
                        $allowScroll: allowScroll,
                        children: children
                    }),
                    footer
                ]
            })
        })
    });
});


/***/ }),

/***/ 72131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86868);
/* harmony import */ var _vette_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21206);




// eslint-disable-next-line @typescript-eslint/no-explicit-any
const recursiveTrimValue = (value)=>_vette_common_utils__WEBPACK_IMPORTED_MODULE_2__/* .recursiveApplyTransformation */ .P(value, (val)=>val.trim());
const Form = (param)=>{
    let { onFinish , ...formProps } = param;
    const onFinishWrapper = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value)=>{
        const trimmedValue = recursiveTrimValue(value);
        return onFinish === null || onFinish === void 0 ? void 0 : onFinish(trimmedValue);
    }, [
        onFinish
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        onFinish: onFinishWrapper,
        ...formProps
    });
};
Form.useForm = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useForm */ .Z.useForm;
Form.useFormInstance = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useFormInstance */ .Z.useFormInstance;
Form.useWatch = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useWatch */ .Z.useWatch;
Form.List = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].List */ .Z.List;
Form.ErrorList = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ErrorList */ .Z.ErrorList;
Form.Item = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Item */ .Z.Item;
Form.Provider = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Provider */ .Z.Provider;
Form.create = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].create */ .Z.create;


/***/ }),

/***/ 74606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ FormItem_FormItem; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/common-utils/src/helpers.ts
var helpers = __webpack_require__(21206);
// EXTERNAL MODULE: ../../node_modules/antd/es/grid/index.js
var grid = __webpack_require__(68358);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FloatLabel/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  & .ant-input {\n    padding-top: 16px;\n    padding-bottom: 8px;\n  }\n\n  & .react-tel-input > .ant-input {\n    padding-top: 18px;\n    padding-bottom: 6px;\n    height: 50px;\n  }\n\n  & .label {\n    font-size: 15px;\n    font-weight: normal;\n    position: absolute;\n    pointer-events: none;\n    left: 12px;\n    top: 12px;\n    transition: 0.2s ease all;\n    color: ",
        ";\n  }\n\n  & .label-float {\n    top: 5px;\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const MinimalInput = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey30;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FloatLabel/index.tsx



const FloatLabel = (param)=>{
    let { label , value , children  } = param;
    const [focus, setFocus] = (0,react.useState)(false);
    const labelClass = focus || value && (value === null || value === void 0 ? void 0 : value.length) !== 0 ? "label label-float" : "label";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MinimalInput, {
        className: "float-label",
        onBlur: ()=>setFocus(false),
        onFocus: ()=>setFocus(true),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: labelClass,
                children: label
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx + 19 modules
var styles = __webpack_require__(71951);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Form/index.tsx
var Form = __webpack_require__(72131);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &.ant-form-item-has-error .ant-form-item-label > label {\n        color: #ff4d4f;\n      }\n    "
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      & .ant-form-item-label > label .ant-form-item-tooltip {\n        background: ",
        ";\n        color: ",
        ";\n        border-radius: 50%;\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  margin-bottom: 0;\n\n  ",
        "\n  &\n    .ant-form-item-label {\n    padding-bottom: 0;\n    white-space: unset;\n    text-align: left;\n    line-height: 1.6;\n\n    > label {\n      height: fit-content;\n      margin-top: 5px;\n      margin-bottom: 5px;\n    }\n\n    > label::after {\n      display: none;\n    }\n  }\n\n  &\n    .ant-form-item-label\n    > label.ant-form-item-required:not(\n      .ant-form-item-required-mark-optional\n    )::before {\n    display: none;\n  }\n\n  & .ant-form-item-control {\n    width: 100%;\n  }\n\n  .ant-form-item-with-help .ant-form-item-explain {\n    min-height: 0px;\n  }\n\n  .ant-form-item-explain-error {\n    font-size: 10px;\n  }\n\n  &.ant-form-item-has-error .ant-input {\n    border-color: #ff4d4f;\n    box-shadow: ",
        ";\n  }\n\n  ",
        "\n\n  .ant-input-status-error {\n    box-shadow: ",
        ";\n  }\n\n  .ant-select-status-error > .ant-select-selector {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -15px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 20px;\n  max-height: 50px;\n  overflow-y: scroll;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  font-weight: 600;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}


const { Item  } = Form/* Form */.l;
const FormItem = (0,styled_components_browser_esm/* default */.ZP)(Item)(_templateObject2(), (param)=>{
    let { $redLabelOnError  } = param;
    return $redLabelOnError && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject());
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
}, (param)=>{
    let { $hasToolTip  } = param;
    return $hasToolTip && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), (param)=>{
        let { theme  } = param;
        return theme.colors.grey60;
    }, (param)=>{
        let { theme  } = param;
        return theme.colors.white;
    });
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
});
const CustomErrorDisplay = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
const List = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject4());
const ListItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.red60;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/index.tsx








// eslint-disable-next-line @typescript-eslint/no-explicit-any
const recursiveTrimStartValue = (value)=>{
    return helpers/* recursiveApplyTransformation */.P(value, (val)=>val.trimStart());
};
const FormItem_FormItem = (param)=>{
    let { ignoreNormalize , compact , customError , redLabelOnError =false , ...formItemProps } = param;
    const { xs  } = grid/* default.useBreakpoint */.ZP.useBreakpoint();
    const [currentValue, setCurrentValue] = (0,react.useState)(formItemProps.initialValue);
    const customErrorBox = customError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomErrorDisplay, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                $size: 9,
                $weight: 600,
                $color: theme/* theme.colors.red60 */.r.colors.red60,
                children: customError.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                children: customError.errors.map((e, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                        children: e
                    }, index))
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (compact && xs) {
        const { label , ...restFormItemProps } = formItemProps;
        const normalize = (value)=>{
            const finalValue = !ignoreNormalize ? recursiveTrimStartValue(value) : value;
            setCurrentValue(finalValue);
            return finalValue;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatLabel, {
            label: formItemProps.label,
            value: currentValue,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem, {
                    $redLabelOnError: redLabelOnError,
                    normalize: normalize,
                    ...restFormItemProps
                }),
                customErrorBox
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem, {
                $redLabelOnError: redLabelOnError,
                normalize: !ignoreNormalize ? recursiveTrimStartValue : undefined,
                ...formItemProps,
                $hasToolTip: !!formItemProps.tooltip
            }),
            customErrorBox
        ]
    });
};


/***/ }),

/***/ 68880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/antd/es/input/index.js + 5 modules
var input = __webpack_require__(61341);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx + 19 modules
var styles = __webpack_require__(71951);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Input/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  margin-top: 4px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Hint = (0,styled_components_browser_esm/* default */.ZP)(styles/* Text */.xv)(_templateObject());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Input/index.tsx




const Input = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { size ="large" , optionalText , ...props } = param;
    const inputRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>{
        return {
            focus: ()=>{
                var ref;
                return (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        };
    });
    const numberValidatorProp = (e)=>{
        props.type === "number" && [
            "e",
            "E",
            "+",
            "-"
        ].includes(e.key) && e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                ...props,
                onKeyDown: numberValidatorProp,
                size: size,
                ref: inputRef
            }),
            optionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hint, {
                type: "secondary",
                children: optionalText
            })
        ]
    });
});


/***/ }),

/***/ 81983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Space; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58694);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94187);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: 100%;\n      "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        padding: ",
        ";\n      "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          width: 100%;\n        "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          display: flex;\n          justify-content: center;\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n\n  & > .ant-space-item {\n    ",
        "\n\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const Space = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject4(), (param)=>{
    let { $fullWidth  } = param;
    return $fullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
}, (param)=>{
    let { $padding  } = param;
    return $padding && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), $padding);
}, (param)=>{
    let { $fullWidth  } = param;
    return $fullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
}, (param)=>{
    let { $centerVertically  } = param;
    return $centerVertically && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3());
});


/***/ }),

/***/ 77435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Tooltip; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Tooltip/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background-color: transparent;\n  color: ",
        ";\n  font-weight: 300;\n  box-shadow: none;\n  font-size: 15px;\n  padding: 0;\n  margin: 0;\n  height: auto;\n\n  :hover {\n    border: none;\n    background-color: transparent;\n    color: ",
        ";\n  }\n\n  :active {\n    order: none;\n    background-color: transparent;\n    color: ",
        ";\n  }\n\n  :focus {\n    order: none;\n    background-color: transparent;\n    color: ",
        ";\n  }\n\n  :selected {\n    order: none;\n    background-color: transparent;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const HoverableButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    className: "ant-btn"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
});

// EXTERNAL MODULE: ../../node_modules/antd/es/tooltip/index.js + 3 modules
var tooltip = __webpack_require__(55003);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Tooltip/index.tsx




const Tooltip = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverableButton, {
            children: props.children
        })
    });
};


/***/ }),

/***/ 52592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useWarning; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _WarningProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28921);


const useWarning = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_WarningProvider__WEBPACK_IMPORTED_MODULE_1__/* .WarningProvider.Context */ .j.Context);
};


/***/ })

}]);